import { render, staticRenderFns } from "./FattorinoOfferList.vue?vue&type=template&id=65cec17a&"
import script from "./FattorinoOfferList.vue?vue&type=script&lang=ts&"
export * from "./FattorinoOfferList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports